/**
 * This comes from PD2_Payment::CARD_TYPE_* in the backend
 * I named this CARD_LOGO since that's what we are returning from the server
 * and `paymentType` was already taken by the `paymentType` enum which lives on th
 * PaymentCard class in the backend
 */
export const CARD_LOGO = {
	VISA: 0,
	MASTERCARD: 1,
	AMEX: 2,
	DISCOVER: 3,
	JCB: 4,
	DINERSCLUB: 5,
	UNKNOWN: 6,
} as const;
export type TCardLogo = typeof CARD_LOGO[keyof typeof CARD_LOGO];


export const CARD_LOGO_LABELS: Record<TCardLogo, string> = {
	[CARD_LOGO.VISA]: 'Visa',
	[CARD_LOGO.MASTERCARD]: 'MasterCard',
	[CARD_LOGO.AMEX]: 'AmericanExpress',
	[CARD_LOGO.DISCOVER]: 'Discover',
	[CARD_LOGO.JCB]: 'JCB',
	[CARD_LOGO.DINERSCLUB]: 'DinersClub',
	[CARD_LOGO.UNKNOWN]: 'NotSet',
};
